const state = {
    selected: [],
};

export default state;



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuetable2/checkbox/state/state.js